'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { useInterval } from '@qogita/react-hooks/use-interval'
import { useState } from 'react'

/**
 * Returns the remaining time in milliseconds until the given expiry timestamp.
 *
 * When stocklistExpiresAt is null, the hook returns null & no interval is scheduled.
 * When a timestamp is provided, it recomputes expiresAt - Date.now() every second.
 */
export function useStockExpiryTimer(
  stocklistExpiresAt: string | null,
): number | null {
  const [remaining, setRemaining] = useState<number | null>(null)

  useInterval(
    () => {
      if (!stocklistExpiresAt) return
      const expiresAtInMs = new Date(stocklistExpiresAt).getTime()
      setRemaining(expiresAtInMs - Date.now())
    },
    stocklistExpiresAt ? 1000 : null,
  )

  return stocklistExpiresAt ? remaining : null
}
